export const PDF_ONLY_ERROR = "Only PDF files are allowed.";
export const NO_ORG_ERROR = "No organization selected. Choose a client before uploading documents.";
export const UPLOAD_FAILED_ERROR = "Upload failed. Remove the file and try again.";

export function isPdfFile(file) {
  if (!file) return false;
  const typeOk = file.type === "application/pdf";
  const nameOk = /\.pdf$/i.test(file.name || "");
  return typeOk && nameOk;
}

export function filterPdfFiles(fileList) {
  const files = Array.from(fileList || []);
  const accepted = [];
  let rejected = false;

  for (const file of files) {
    if (isPdfFile(file)) accepted.push(file);
    else rejected = true;
  }

  return { accepted, rejected };
}

export function createSubmissionDocument(file, seq) {
  return {
    id: "doc-" + seq,
    file,
    fileName: file.name,
    fileType: file.type || "application/pdf",
    status: "uploading",
    progress: 0,
  };
}
